module.exports = __webpack_public_path__ + "static/assets/89e4db19973133299e2c7d7cb8be7ff5.svg";